import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { v4 as uuidv4 } from 'uuid';
import { UserMissionCategoryPopulated } from '@gamiphy/bl/mission';
import { EventsStore } from '@gamiphy/loyalty-station-desktop/store/events';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';

/**
 * checks for a valid URL and redirects the page to it
 * @param userMission
 */
export const handleGoToUrl = (userMission: UserMissionCategoryPopulated): void => {
  const url = userMission.mission.cta?.attributes?.url as string | undefined;
  const timeout = userMission.mission.cta?.attributes?.timeout as number | undefined;
  const target = userMission.mission.cta?.attributes?.target as string | undefined;

  if (url) {
    try {
      const customUrl = new URL(url);

      if (target) {
        window.open(customUrl, target);
      } else {
        window.location.href = customUrl.href;
      }

      if (timeout) {
        setTimeout(() => {
          void EventsStore.legacyApi.legacyEventsControllerCreatePublicEvent(AppStore.app.id, {
            uuid: uuidv4(),
            type: userMission.mission.requirements.events[0],
            metadata: {
              url,
            },
          });
        }, timeout);
      }
    } catch {
      // do nothing
    }
  }
  void UiStore.setPage(Pages.home);
};

export const handleOpenPopupMission = (userMission: UserMissionCategoryPopulated): void => {
  const url = userMission.mission.cta?.attributes?.url as string | undefined;
  const timeout = userMission.mission.cta?.attributes?.timeout as number | undefined;

  if (url) {
    try {
      window.open(url, url, 'popup=true')?.focus();

      setTimeout(() => {
        void EventsStore.legacyApi.legacyEventsControllerCreatePublicEvent(AppStore.app.id, {
          uuid: uuidv4(),
          type: userMission.mission.requirements.events[0],
          metadata: {
            url,
          },
        });
      }, timeout ?? 10000);
    } catch {
      // do nothing
    }
  }
};
